import React from 'react'
import PropTypes from 'prop-types'
import { createGlobalStyle, ThemeProvider } from 'styled-components'
import reset from 'styled-reset'
import { Helmet } from 'react-helmet'

import BoldWoff2 from '../resources/fonts/AeonikPro-Bold.woff2'
import BoldWoff from '../resources/fonts/AeonikPro-Bold.woff'
import RegularWoff2 from '../resources/fonts/AeonikPro-Regular.woff2'
import RegularWoff from '../resources/fonts/AeonikPro-Regular.woff'
import theme from '../config/theme'

const GlobalStyle = createGlobalStyle`
  ${reset}
 
  @font-face {
    font-weight: 400;
    font-family: 'Aeonik Pro';
    src: url(${RegularWoff2}) format('woff2'),
      url(${RegularWoff}) format('woff');
    font-display: swap;
  }
  @font-face {
    font-weight: 700;
    font-family: 'Aeonik Pro';
    src: url(${BoldWoff2}) format('woff2'),
      url(${BoldWoff}) format('woff');
    font-display: swap;
  }
  
  html, body {
    overflow-x: hidden;
    scroll-behavior: smooth;
    font-family: ${theme.fonts.aeonikPro};
  }
`

const Root = ({ children }) => (
  <>
    <Helmet>
      <link rel="preload" as="font" href={RegularWoff2} type="font/woff2" crossOrigin="anonymous" />
      <link rel="preload" as="font" href={BoldWoff2} type="font/woff2" crossOrigin="anonymous" />
    </Helmet>
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      {children}
    </ThemeProvider>
  </>
)

Root.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  children: PropTypes.any,
}

Root.defaultProps = {
  children: null,
}

export default Root
